import { render, staticRenderFns } from "./BottomSheetAcceptNotifications.vue?vue&type=template&id=51e0ee70&scoped=true&"
import script from "./BottomSheetAcceptNotifications.vue?vue&type=script&lang=js&"
export * from "./BottomSheetAcceptNotifications.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetAcceptNotifications.vue?vue&type=style&index=0&id=51e0ee70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e0ee70",
  null
  
)

export default component.exports